import * as i0 from "@angular/core";
/**
 * A tiny service to save router state without accessing document
 * Currently makes use of router.events, see LayoutComponent
 */
export class RoutingStateService {
    constructor() {
        this.history = [];
        this.startHistoryIndex = history.length;
    }
    saveRouting(previousUrl) {
        const url = (previousUrl || '').split('?')[0];
        if (url !== '/') {
            this.history = [...this.history, previousUrl];
        }
    }
    getPreviousUrl() {
        const l = this.history.length;
        return this.history[((l >= 2) ? l - 2 : 0)];
    }
    /**
     * Calculate the number of navigation required to get to
     * the first history index when on application load
     */
    getFirstNavigationPage() {
        return history.length - (history.length - this.startHistoryIndex);
    }
}
RoutingStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoutingStateService_Factory() { return new RoutingStateService(); }, token: RoutingStateService, providedIn: "root" });
